import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import { CommonAction } from '@stores/common/action';
import type { LotteryAction } from '@stores/lottery/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { setThemeColor, toRgba, hexToRgb, getThemeColor } from '@utils/colorConversion';

interface RouteParams {
    code: string;
}
interface LotteryProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    lottery?: LotteryAction;
    common?: CommonAction;
}

interface LotteryState {
    loading: boolean;
    error: any
    pageLoaded: any
    lotteryDetail: any
    navList: any
    navCurrentIndex: any
    navCurrentType: any
    themeColor: any
}
@inject('app', 'lottery', 'common')
@observer
class Lottery extends BasePage<LotteryProps, LotteryState> {
    namespace='Lottery';
    lotteryCode: any = '';    // 抽奖id
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        lotteryDetail: {},  // 抽奖详情
        navList: [
            {name: '试用', id: 0, type: '0'},
            {name: '我的', id: 1, type: '1'},
        ],
        navCurrentIndex: 0, // 导航当前选中索引
        navCurrentType: '',
        themeColor: '',  //主题色
    };
    componentDidMount() {
        document.title = '抽奖';
        const { app, user, match } = this.props;
        this.lotteryCode = match.params.code;
        // 初始化获取详情
        this.getLotteryActivities();
        super.componentDidMount();
    }

    componentWillUnmount() {
        document.title = '';
    }

    // 获取抽奖详情
    getLotteryActivities = async() => {
        const { lottery } = this.props;
        const res = await lottery.getLotteryActivitiesData(this.lotteryCode);
        if(res.code == 0) {
            this.setState({
                lotteryDetail: res.data
            }, () => {
                // 设置主题色 - setThemeColor 会同时设置 --lottery-theme-color 和 --lottery-theme-color-rgb
                const color = res.data?.foregroundColor;
                if (color) {
                    setThemeColor(color, 'lottery-theme-color');
                    this.setState({
                        themeColor: color
                    });
                }
            })
            document.title = res.data?.name;
        } else {
            this.props.history.push(`/`);
        }
    }

    // 类型切换
    navClick = (item:any, index:any) => {
        this.setState({
            navCurrentIndex: index,
            navCurrentType: item.type
        }, () => {
            // this.getProductList();
        })
    }

    // 更新抽奖详情数据
    updateLotteryDetail = (newDetail: any) => {
        this.setState({
            lotteryDetail: newDetail
        });
    }

    render() {
        const { app, lottery } = this.props;
        const { navList, navCurrentIndex, lotteryDetail, themeColor } = this.state;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    {...this.props}
                    navList={navList}
                    navCurrentIndex={navCurrentIndex}
                    navClick={this.navClick}
                ></PC>) : (
                    <H5
                        {...this.props}
                        navList={navList}
                        navClick={this.navClick}
                        navCurrentIndex={navCurrentIndex}
                        lotteryDetail={lotteryDetail}
                        themeColor={themeColor}
                        updateLotteryDetail={this.updateLotteryDetail}
                    ></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(Lottery);